import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { StorageService } from 'src/app/core/services/storage.service';
import { VisualThemeModeService } from 'src/app/core/services/visual-theme-mode.service';

@Component({
  selector: 'app-later-page',
  templateUrl: './later-page.component.html',
  styleUrls: ['./later-page.component.scss'],
})
export class LaterPageComponent implements OnInit {

  constructor(private router: Router, private visualThemeModeService: VisualThemeModeService,
    private storageService: StorageService) { }

  ngOnInit() { }


  backPairDevice() {
    this.router.navigateByUrl("/common/pick-device");
  }

  goToPestTrapp() {
    this.visualThemeModeService.setPesTrappTheme().subscribe(e => {
      this.router.navigate(["/pesttrapp/home"]);
    });
  }

  goToFiliz() {
    this.visualThemeModeService.setFilizTheme().subscribe(e => {
      this.router.navigate(["/filiz/home"]);
    });
  }
}
